import IVehicle from '../models/IVehicle';
import AbstractCRUDService from './AbstractCRUDService';
import axios from '../config/axios';

class VehicleService extends AbstractCRUDService<IVehicle> {
  async resetStatus(vehicleId: number): Promise<{
    id: number;
    rowCount: number;
    msg: string;
  }> {
    return axios.patch(`${this.basePath}/reset/status/${vehicleId}`);
  }
}

export default new VehicleService('logistics/vehicle');
